import axios from "axios";
import { baseUrl } from "../../config/clientsConfig";



const CallLogService = {

    getCallLogHistory: (docId, date) => {
      return axios.get(`${baseUrl}/analytics/callLog-History?docId=${docId}&startDate=${date}` );
    },
    getCallLogSummary: (body) => {
      return axios.post(`${baseUrl}/analytics/call-summary`, body);
    },
    getCallLogsSummaryDownload: (body) => {
      return axios.post(`${baseUrl}/analytics/call-summary-excel`, body,);
    },
    getLeadCallLogsHistory: (body) => {
      return axios.post(`${baseUrl}/call-logs/history`, body);
    }
}
export default CallLogService;